<template>
  <v-row>
    <v-col cols="9">
      <p class="float-left">Applied Filters</p>

      <span v-for="(item, key) in photoFilter" :key="key">
          <v-chip v-if="key=='fromDt' && item != null " class="ma-2">
            From Date - {{ item }}
          </v-chip>

          <v-chip v-else-if="key=='thruDt' && item != null " class="ma-2; thruDt" >
            Thru Date - {{ item }}
          </v-chip>

          <v-chip v-else-if="key=='respIdSearchFreeForm' && item"  class="ma-2; massSearch">
            Response ID: {{ item }}
          </v-chip>

          <v-chip v-else-if="key=='rgidSearchFreeForm' && item"  class="ma-2; massSearch">
            Response Group ID: {{ item }}
          </v-chip>

          <v-chip v-else-if="key=='question_id' && item"  class="ma-2; massSearch">
            Question ID: {{ item }}
          </v-chip>

        </span>

    </v-col>
    <v-col cols="3">
      <v-row>
        <v-col cols="3">
          <filter-btn :dialog="dialog" class="mr-0">
            <photo-filter-modal :photoFilters="photoFilter"
                                :retailerChoices="retailers"
                                :departmentChoices="departments"
                                @apply-filters="applyFilters($event)"
                                @dialog-clicked="handleDialogClicked($event)"
                                @modal-mounted="dialog = true"
            />
          </filter-btn>
        </v-col>
        <v-col cols="9">
          <v-btn class="mr-0" color="primary" small @click="resetFilters">
            Reset Filters
          </v-btn>
        </v-col>
      </v-row>

    </v-col>
  </v-row>
</template>

<script>
import axios from "axios";
import FilterBtn from '../btns/FilterBtn.vue'
import PhotoFilterModal from './PhotoFilterModal.vue'
import {mapActions, mapState} from 'vuex'


export default {
  name: 'PhotoFilter',
  components: {
    PhotoFilterModal,
    FilterBtn
  },
  props: {
    isQc: {
      type: Boolean,
      default: false
    },
    isSa: {
      type: Boolean,
      default: false
    },
    initialFilter: {
      type: Object
    }
  },
  data() {
    return {
      dialog: false,
      retailers: [],
      departments: [],
      photoFilter: {
        fromDt: null,
        thruDt: null,
        tags: [],
        projects: [],
        jobs: [],
        onlyUntagged: true,
        includePartiallyTagged: true,
        includeInactive: false,
        respIdSearchFreeForm: null,
        rgidSearchFreeForm: null,
        question_id: null,
        country: null,
        retailer: null,
        department: null
      }
    }
  },
  async mounted () {
    this.get_retailer_list()
    this.get_department_list()
    this.photoFilter.fromDt = this.initialFilter.fromDt
    this.photoFilter.thruDt = this.initialFilter.thruDt
    this.photoFilter.tags = this.initialFilter.tags
    this.photoFilter.projects = this.initialFilter.projects
    this.photoFilter.jobs = this.initialFilter.jobs
    this.photoFilter.onlyUntagged = this.initialFilter.onlyUntagged
    this.photoFilter.includePartiallyTagged = this.initialFilter.includePartiallyTagged !== undefined
        ? this.initialFilter.includePartiallyTagged : true
    this.photoFilter.includeInactive = this.initialFilter.includeInactive === true
    this.photoFilter.respIdSearchFreeForm = this.initialFilter.respIdSearchFreeForm
    this.photoFilter.rgidSearchFreeForm = this.initialFilter.rgidSearchFreeForm
    this.photoFilter.question_id = this.initialFilter.question_id
    this.photoFilter.country = this.initialFilter.country
    this.photoFilter.retailer = this.initialFilter.retailer
    // IT-709: restored beside retailer, which it always should have been —
    // a department selection was silently lost on every re-mount.
    this.photoFilter.department = this.initialFilter.department
  },
  computed: {
    ...mapState({
      projects: state => state.photos.projects,
      jobs: state => state.photos.jobs,
      tags: state => state.tags.tags,
    })
  },
  watch: {},
  methods: {
    ...mapActions(['getPhotosList',  'getSAList', 'getQCList', 'getFilteredPhotos']),
    async get_retailer_list() {
        this.$store.commit('UPDATE_STORE_ARRAY_DATA', {
            fields: [{ 'keys': ['loading_list'], 'value': 'get_retailer_list', action: 'toggle' },]
        });

        let new_this = this;
        return new Promise((resolve, reject) => {
            axios.get('/api/retailers').then(response => {
                let data = response.data;
                new_this.retailers = data;
                resolve(response.data);
            }).catch(e => {
                console.log(e);
                reject(e);
            }).finally(() => {
                new_this.$store.commit('UPDATE_STORE_ARRAY_DATA', {
                    fields: [{ 'keys': ['loading_list'], 'value': 'get_retailer_list', action: 'toggle' },]
                });
            });
        });
    },
    async get_department_list() {
        this.$store.commit('UPDATE_STORE_ARRAY_DATA', {
            fields: [{ 'keys': ['loading_list'], 'value': 'get_department_list', action: 'toggle' },]
        });

        let new_this = this;
        return new Promise((resolve, reject) => {
            axios.get('/api/departments').then(response => {
                let data = response.data;
                new_this.departments = data;
                resolve(response.data);
            }).catch(e => {
                console.log(e);
                reject(e);
            }).finally(() => {
                new_this.$store.commit('UPDATE_STORE_ARRAY_DATA', {
                    fields: [{ 'keys': ['loading_list'], 'value': 'get_department_list', action: 'toggle' },]
                });
            });
        });
    },
    handleDialogClicked(val) {
      this.dialog = false
    },
    applyFilters(filterValues) {

      if (filterValues.fromDt != null) {
        this.photoFilter.fromDt = filterValues.fromDt
      } else {
        this.photoFilter.fromDt = null
      }

      if (filterValues.thruDt != null){
        this.photoFilter.thruDt = filterValues.thruDt
      } else {
        this.photoFilter.thruDt = null
      }

      if (filterValues.tags){
        this.photoFilter.tags = filterValues.tags
      } else {
        this.photoFilter.tags = []
      }

      if (filterValues.projects){
        this.photoFilter.projects = filterValues.projects
      } else {
        this.photoFilter.projects = []
      }

      if (filterValues.jobs){
        this.photoFilter.jobs = filterValues.jobs
      } else {
        this.photoFilter.jobs = []
      }

      if (filterValues.respIdSearchFreeForm){
        this.photoFilter.respIdSearchFreeForm = filterValues.respIdSearchFreeForm
        // this.photoFilter.respIdSearchFreeForm = string_this_way.match(/\d+/g)
      } else {
        this.photoFilter.respIdSearchFreeForm = null
      }

      if (filterValues.rgidSearchFreeForm){
        this.photoFilter.rgidSearchFreeForm = filterValues.rgidSearchFreeForm
      } else {
        this.photoFilter.rgidSearchFreeForm = null
      }

      if (filterValues.question_id){
        this.photoFilter.question_id = filterValues.question_id
      } else {
        this.photoFilter.question_id = null
      }

      this.photoFilter.onlyUntagged = filterValues.onlyUntagged
      this.photoFilter.includePartiallyTagged = filterValues.includePartiallyTagged
      this.photoFilter.includeInactive = filterValues.includeInactive === true
      this.photoFilter.country = filterValues.country
      this.photoFilter.retailer = filterValues.retailer
      this.photoFilter.department = filterValues.department

      this.dialog = false
      this.$emit('apply-filters', this.photoFilter)
    },
    resetFilters() {
      this.photoFilter.fromDt = null
      this.photoFilter.thruDt = null
      this.photoFilter.tags = []
      this.photoFilter.projects = []
      this.photoFilter.jobs = []
      this.photoFilter.onlyUntagged = true
      this.photoFilter.includePartiallyTagged = true
      this.photoFilter.includeInactive = false
      this.photoFilter.respIdSearchFreeForm = null
      this.photoFilter.rgidSearchFreeForm = null
      this.photoFilter.question_id = null
      this.photoFilter.country = null
      this.photoFilter.retailer = null
      this.photoFilter.department = null
      this.$emit('apply-filters', this.photoFilter)
    },

  }
}
</script>

<style>
</style>
